
import React from 'react';
import ReactDOM from 'react-dom';

import './i18n';

import App from './App';
import reportWebVitals from './reportWebVitals';
import CookiesDemo from 'crm/other/Contact/CookiesDemo';
import { HelmetProvider } from 'react-helmet-async'; // ✅ import HelmetProvider

ReactDOM.render(
    <React.StrictMode>
        <HelmetProvider>
            <App />
            <CookiesDemo />
        </HelmetProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// Performance measuring
reportWebVitals();
